import React from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

const ShareLinkDisabledModal = ({ closeModal }) => (
  <div className="confirmation-modal-wrapper">
    <ConfirmDialog
      title="Requested Quiz Is Not Available"
      content={{
        btnPrimary: 'OK',
      }}
      onClose={closeModal}
      onSuccess={closeModal}
    >
      <p>
        This quiz is not available because it is no longer being shared or has
        been deleted.
      </p>
    </ConfirmDialog>
  </div>
);

export default ShareLinkDisabledModal;
